// extracted by mini-css-extract-plugin
module.exports = {"root":"classes_root__WQyCz","title":"classes_title__14BT8","sets":"classes_sets__1Cj_g"};